module.exports = __webpack_public_path__ + "static/media/trips-demo.b3cd6c14.png";